<template>
    <div class="instagram-progress">
        <div class="card">
            <div class="card-header">
                <h5 class="header-case">ENGAGEMENT GROWTH</h5>
            </div>
            <div class="card-body">
                <line-chart
                    id="chart"
                    style="height: 300px"
                    v-if="mounted"
                    :chartdata="cchartData"
                    :rendering-options="renderingOptions"
                    :options="options"></line-chart>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import VueCharts from 'vue-chartjs'
    import LineChart from '../charts/line-chart'

    export default {
        components: {LineChart},
        mixins: [VueCharts.mixins.reactiveData],
        props: ['data'],
        watch: {
            data: function(newValue, oldValue) {
                // this.setupChart()
            }
        },
        computed: {
            cchartData() {
                const newChartData = {...this.baseChartData}

                newChartData.labels = []
                newChartData.datasets[0].data = []
                newChartData.datasets[1].data = []

                for (let point of this.data) {
                    newChartData.labels.push(point.date)
                    newChartData.datasets[0].data.push(point.engagement)
                    newChartData.datasets[1].data.push(point.totalPosts)
                }

                return newChartData
            }
        },
        methods: {
            
        },
        mounted() {
            this.mounted = true
            // this.setupChart()
        },
        data() {
            return {
                mounted: false,
                renderingOptions: [
                    {
                        index: 0,
                        fillRule: null,
                        backgroundColor: 'rgb(255, 255, 255)'
                    },
                    {
                        index: 1,
                        fillRule: true,
                        gradient: true,
                        backgroundColor: 'rgba(0, 0, 0, 0.14)',
                        backgroundColorEnd: 'rgba(255, 255, 255, 0.14)'
                    }
                ],
                baseChartData: {
                    labels: [],
                    datasets: [
                        {
                            label: 'Engagement',
                            type: 'line',
                            data: [],
                            fill: false,
                            borderColor: 'rgb(0, 173, 241)',
                            lineTension: 0,
                            pointBackgroundColor: 'rgba(255, 255, 255, 1)',
                            pointStrokeColor: 'rgba(0, 173, 241, 1)',
                            pointRadius: 5,
                            pointHitDetectionRadius : 15,
                            pointBorderWidth: 2.5,
                            yAxisID: 'y-axis-1'
                        },
                        {
                            label: 'Posts',
                            type: 'line',
                            data: [],
                            fill: true,
                            lineTension: 0,
                            pointStrokeColor: 'rgba(0,0,0,0)',
                            strokeColor: 'rgba(0,0,0,0)',
                            borderColor: 'rgba(0,0,0,0)',
                            yAxisID: 'y-axis-2',
                            categoryPercentage: 0.3,
                            backgroundColor: '#000',
                            pointBackgroundColor: 'rgba(255, 255, 255, 0)'
                        }
                    ]
                },
                options: {
                    labels: ['Total Engagement', 'Posts', 'Creators'],
                    colors: ['#00afef'],
                    title: 'Social Progress',
                    legend: {
                        display: false,
                        position: 'bottom'
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    scales : {
                        yAxes : [
                            {
                                type: 'linear',
                                id: 'y-axis-1',
                                ticks : {
                                    // max: 100,
                                    // stepSize: 20,
                                    beginAtZero: true,
                                    fontColor: '#9696a4'
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: 'Engagement',
                                    fontColor: '#9696a4'
                                },
                                gridLines: {
                                    color: "rgb(173, 173, 173, 0.2)"
                                }
                            },
                            {
                                ticks: {
                                    // max: 5,
                                    beginAtZero: true,
                                    fontColor: '#9696a4'
                                    // stepSize: 1
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: 'Posts',
                                    fontColor: '#9696a4'
                                },
                                position: 'right',
                                type: 'linear',
                                id: 'y-axis-2',
                                gridLines: {
                                    display: false,
                                    color: "#f2f2f2"
                                }
                            }
                        ],
                        xAxes : [
                            {
                                display: false,
                                scaleLabel: {
                                    display: true,
                                    labelString: 'T I M E'
                                },
                                gridLines: {
                                    display: false
                                }
                            },
                            {
                                gridLines: {
                                    display: false
                                }
                            }
                        ]
                    }
                }
            }
        }
    }
</script>
